/* raw layout hash: _compliance-audit-trail-explorer-layout:4081031a866ade9e8512f6a4aa318bbfce48fa50b52c447c718891e5aaa499ad */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_compliance-audit-trail-explorer-layout" — renders its page content through the router outlet.
export default function ComplianceAuditTrailExplorerLayout() {
  return <AppShell layoutName="_compliance-audit-trail-explorer-layout" menu={LAYOUT_MENUS['_compliance-audit-trail-explorer-layout']} />;
}
